import { Component, Inject, OnInit, Renderer2, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationStart,
  RouteConfigLoadEnd,
  RouteConfigLoadStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { LoadingBarModule, LoadingBarService } from '@ngx-loading-bar/core';
import { LayoutComponent } from './core/layout/layout.component';
import { DOCUMENT } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { MenuService } from './core/layout/services/menu/menu.service';
import { RoutesEnum, RoutesTournamentEnum } from './shared/models/routes.enum';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, LoadingBarModule, LayoutComponent, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private loadingBar = inject(LoadingBarService);
  private router = inject(Router);
  private metaService = inject(Meta);
  private titleService = inject(Title);
  private renderer = inject(Renderer2);
  private menuService = inject(MenuService);

  pageTitle = 'LigaPadla.pl';

  constructor(@Inject(DOCUMENT) private document: Document) {}

  public ngOnInit(): void {
    this.router.events.subscribe(event => {
      const loadingBar = this.loadingBar.useRef();

      if (event instanceof NavigationStart) {
        loadingBar.start();
        if (this.menuService.openedMenu()) {
          this.menuService.closeMenu();
        }
      }
      if (event instanceof RouteConfigLoadStart) {
        loadingBar.increment(35);
      }
      if (event instanceof RouteConfigLoadEnd) {
        loadingBar.increment(75);
      }
      if (event instanceof NavigationEnd) {
        const pageWrapper = this.document.getElementsByClassName('page-wrapper')[0];
        pageWrapper.className = 'page-wrapper';

        switch (true) {
          case event.url === `/${RoutesEnum.Login}`:
          case event.url === `/${RoutesEnum.Register}`:
          case event.url === `/${RoutesEnum.RemindPassword}`:
          case event.url.includes(`/${RoutesEnum.ResetPassword}`):
            this.renderer.addClass(pageWrapper, 'auth-page');
            break;

          case event.url.includes(`/${RoutesEnum.Tournaments}/`) &&
            event.url.includes(`/${RoutesTournamentEnum.TakePart}`):
            this.renderer.addClass(pageWrapper, 'take-part-page');
            break;

          case event.url.includes(`/${RoutesEnum.Tournaments}/`):
            this.renderer.addClass(pageWrapper, 'tournament-page');
            break;

          default:
            break;
        }
        loadingBar.complete();
      }
      if (event instanceof NavigationCancel) {
        loadingBar.complete();
      }
    });

    this.updateMetaTags();
  }

  private updateMetaTags(): void {
    this.titleService.setTitle(this.pageTitle);
    this.metaService.addTags([
      {
        name: 'keywords',
        content: 'liga padla, turnieje, padel, padel tenis, padel polska',
      },
      {
        name: 'description',
        content: 'NAJWIĘKSZA LIGA PADLA dla amatorów w Polsce',
      },
      {
        name: 'og:description',
        content: 'NAJWIĘKSZA LIGA PADLA dla amatorów w Polsce',
      },
      {
        name: 'og:title',
        content: `${this.pageTitle} - rozgrywki padla dla każdego`,
      },
      {
        name: 'og:type',
        content: 'website',
      },
      {
        name: 'og:image',
        content: 'https://rozgrywki.ligapadla.pl/assets/images/og-image-ligapadla.png',
      },
      {
        name: 'og:image:alt',
        content: 'LigaPadla.pl',
      },
      {
        name: 'og:url',
        content: 'https://rozgrywki.ligapadla.pl',
      },
    ]);
  }
}
